import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoModelsLicenseCreateResponse,
  useFormSubmit,
} from "melco-shared-logic";
//import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { DisplayUpgradeLicenseSummary } from "./DisplayUpgradeLicenseSummary";
import { useLicenseManagerUpgrade } from "../../../../hooks/licensemanager/useLicenseManagerUpgrade";
import { NewSelectedValuesForLicenseUpgrade } from "../../drawer/UpgradeLicenseDrawer";

type UpgradeLicenseSummaryProps = {
  callbackFn: (
    obj: ControlcenterMelcoModelsLicenseCreateResponse | undefined
  ) => void;
  stepback: () => void;
  currentLicense: ControlcenterMelcoModelsLicenseCreateResponse | undefined;

  newValuesToUpgrade: NewSelectedValuesForLicenseUpgrade | undefined;
  licenseFormValues: any;
};
export const UpgradeLicenseSummary: React.FC<UpgradeLicenseSummaryProps> = ({
  newValuesToUpgrade,
  licenseFormValues,
  currentLicense,
  stepback,
  callbackFn,
}) => {
  const queryClient = useQueryClient();
  const queryKey = "upgrade-querylicensemanage";

  //const { t } = useTranslation();

  const upgradeLicenseAndSendEmail = useLicenseManagerUpgrade();

  const handleUpgradeLicense = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    /**
     *   * As per requirement by default we have to show Don't assign license switch button off in UI
         * but for backend we have to send true value for it.
         * so we will flip the value , whatever is shown in UI
         * if switch button off then send true
         * if switch button on then send false
    
     */
    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)

    let newEntity: ControlcenterMelcoModelsLicenseCreateResponse | undefined =
      await upgradeLicenseAndSendEmail({
        email_address: currentLicense?.email_address ?? "",
        step: 3,
        serial_number: currentLicense?.serial_number ?? "",
        version_id: newValuesToUpgrade?.new_version_id ?? "",
        subscription_code: newValuesToUpgrade?.new_subscription_code ?? "",
        product_code: currentLicense?.product_code ?? "",
        referral_code: "LICENSE_MANAGER",
        assign_license: !licenseFormValues.assign_license,
        melco_customer_id: licenseFormValues.melco_customer_id,
        language: currentLicense?.language,
      });
    //   //console.log("newEntity",newEntity)
    // console.log(newEntity);

    callbackFn(newEntity);
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    await onUpgradeSerialNumber(values, formikHelpers, {});
  };

  const formSubmitToUpgradeLicense = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        return handleUpgradeLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.Upgrade",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licensemanager", "upgrade"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onUpgradeSerialNumber = useFormSubmit(...formSubmitToUpgradeLicense());

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik initialValues={{}} onSubmit={onSubmit} enableReinitialize>
        <div>
          <DirtyFormPrompt>
            <DisplayUpgradeLicenseSummary
              newValuesToUpgrade={newValuesToUpgrade}
              currentLicense={currentLicense}
              stepback={stepback}
              licenseFormValues={licenseFormValues}
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
